import React from 'react';
import { Input, Button, message } from 'antd';
import { CopyToClipboard } from 'react-copy-to-clipboard';

function BlockDisplay({codeBlock}) {
  const copyMsg = () => {message.success('Copied!');};
  const { TextArea } = Input;

  return (
    <div className="blockContent">
      <div className="blockDisplay" dangerouslySetInnerHTML={{__html: codeBlock}} />

      <div className="blockCode">
        <TextArea rows={15} readOnly value={codeBlock} />
        <CopyToClipboard text={codeBlock}>
          <Button type="primary" onClick={copyMsg}>Copy to clipboard</Button>
        </CopyToClipboard>
      </div>
    </div>
  )
}

export default BlockDisplay;